export const LANGUAGE_LEVEL_MODEL = "language-level";

const languageLevelModel = {
  name: ""
};

export default languageLevelModel;
